import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 md:py-32 bg-[#faf9f7]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="relative rounded-3xl overflow-hidden min-h-[420px] md:min-h-[500px] flex items-center">
          {/* Background */}
          <img
            src="https://readdy.ai/api/search-image?query=modern%20Japanese%20business%20office%20meeting%20room%20with%20panoramic%20city%20view%2C%20clean%20minimalist%20interior%20with%20dark%20navy%20and%20white%20colors%2C%20professional%20consulting%20atmosphere%2C%20natural%20daylight%2C%20sophisticated%20architectural%20design%2C%20high-end%20corporate%20space&width=1280&height=600&seq=cta001&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a2332]/90 via-[#1a2332]/80 to-[#1a2332]/60" />

          {/* Content */}
          <div className="relative z-10 w-full px-8 md:px-16 py-16 text-center">
            <span className="text-xs font-semibold tracking-[3px] text-white/50 uppercase">Free Consultation</span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mt-4 mb-6 leading-tight">
              まずは無料相談から<br />はじめましょう
            </h2>
            <p className="text-base md:text-lg text-white/70 max-w-xl mx-auto leading-relaxed mb-10">
              集客・営業に関するお悩みをお気軽にご相談ください。<br />
              現状分析から具体的な改善策まで、丁寧にご提案いたします。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="px-8 py-4 bg-white text-[#1a2332] font-semibold rounded-full hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                お問合せ
              </Link>
              <Link
                to="/services"
                className="px-8 py-4 border-2 border-white/40 text-white font-semibold rounded-full hover:border-white hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                サービス詳細を見る
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
